import React, { useState, useEffect } from "react";
import { Col, Row, Button, Tab, Nav } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTruckField, faBoxOpen, faArrowsRotate } from "@fortawesome/free-solid-svg-icons";

import SupplierList from "./SupplierList";
import SupplierForm from "./SupplierForm";
import ProductList from "./ProductList";
import ProductForm from "./ProductForm";
import ProductStockForm from "./ProductStockForm";
import SyncStockTab from "./SyncStockTab";
import PopupModal from "../Common/Popup";
import Utils from "../../configs/Utils";
import Enums from "../../configs/Enums";
import "./style.scss";

const SupplierStockBlock = ({ workspaceId }) => {
  const [activeTab, setActiveTab] = useState("products");

  // Suppliers state
  const [supplierPopupShow, setSupplierPopupShow] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [supplierReload, setSupplierReload] = useState(0);

  // Products state
  const [productPopupShow, setProductPopupShow] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [productReload, setProductReload] = useState(0);

  // Stock state
  const [stockPopupShow, setStockPopupShow] = useState(false);
  const [stockProduct, setStockProduct] = useState(null);
  const [suppliers, setSuppliers] = useState([]);

  // Fetch suppliers for stock form dropdown
  useEffect(() => {
    const fetchSuppliers = async () => {
      try {
        const response = await Utils._apiRequest({
          path: Enums.endpoints.supplierStock.SUPPLIERS,
          type: "GET",
          query: { workspace: workspaceId },
        });
        setSuppliers(response.data || []);
      } catch (error) {
        console.log("Failed to fetch suppliers:", error.message);
      }
    };
    fetchSuppliers();
  }, [workspaceId, supplierReload]);

  const handleCreateSupplier = () => {
    setSelectedSupplier(null);
    setSupplierPopupShow(true);
  };

  const handleCreateProduct = () => {
    setSelectedProduct(null);
    setProductPopupShow(true);
  };

  return (
    <>
      <Row>
        <Col md={12}>
          <div className="my-3 p-3 bg-body rounded shadow-sm feature-box supplier-stock-block">
            <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
              <div className="supplier-stock-block__head d-flex justify-content-between align-items-center border-bottom pb-3 mb-3">
                <Nav variant="pills" className="supplier-stock-block__tabs">
                  <Nav.Item>
                    <Nav.Link eventKey="products">
                      <FontAwesomeIcon icon={faBoxOpen} className="me-2" />
                      Sản phẩm
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="suppliers">
                      <FontAwesomeIcon icon={faTruckField} className="me-2" />
                      Suppliers
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="sync-stock">
                      <FontAwesomeIcon icon={faArrowsRotate} className="me-2" />
                      Sync Sheet
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
                <div>
                  {activeTab === "suppliers" && (
                    <Button variant="primary" size="sm" onClick={handleCreateSupplier}>
                      <FontAwesomeIcon className="me-2" icon={faPlus} />
                      Thêm Supplier
                    </Button>
                  )}
                  {activeTab === "products" && (
                    <Button variant="primary" size="sm" onClick={handleCreateProduct}>
                      <FontAwesomeIcon className="me-2" icon={faPlus} />
                      Thêm sản phẩm
                    </Button>
                  )}
                </div>
              </div>

              <Tab.Content>
                <Tab.Pane eventKey="suppliers">
                  <SupplierList
                    workspaceId={workspaceId}
                    setSelectedSupplier={setSelectedSupplier}
                    setPopupShow={setSupplierPopupShow}
                    reload={supplierReload}
                  />
                </Tab.Pane>
                <Tab.Pane eventKey="products">
                  <ProductList
                    workspaceId={workspaceId}
                    suppliers={suppliers}
                    setSelectedProduct={setSelectedProduct}
                    setProductPopupShow={setProductPopupShow}
                    setStockProduct={setStockProduct}
                    setStockPopupShow={setStockPopupShow}
                    reload={productReload}
                  />
                </Tab.Pane>
                <Tab.Pane eventKey="sync-stock">
                  <SyncStockTab workspaceId={workspaceId} />
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>
        </Col>
      </Row>

      {/* Supplier Form Modal */}
      <PopupModal
        title={selectedSupplier ? "Sửa Supplier" : "Tạo Supplier"}
        popupShow={supplierPopupShow}
        setPopupShow={setSupplierPopupShow}
        size="lg"
        dialogClassName="supplier-stock-modal"
        bodyClassName="supplier-stock-modal-body"
      >
        <SupplierForm
          workspaceId={workspaceId}
          setPopupShow={setSupplierPopupShow}
          refreshList={() => setSupplierReload((prev) => prev + 1)}
          selectedSupplier={selectedSupplier}
        />
      </PopupModal>

      {/* Product Form Modal */}
      <PopupModal
        title={selectedProduct ? "Sửa sản phẩm" : "Tạo sản phẩm"}
        popupShow={productPopupShow}
        setPopupShow={setProductPopupShow}
        size="lg"
        dialogClassName="supplier-stock-modal"
        bodyClassName="supplier-stock-modal-body"
      >
        <ProductForm
          workspaceId={workspaceId}
          setPopupShow={setProductPopupShow}
          refreshList={() => setProductReload((prev) => prev + 1)}
          selectedProduct={selectedProduct}
        />
      </PopupModal>

      {/* Stock Management Modal */}
      <PopupModal
        title="Quản lý Stock"
        popupShow={stockPopupShow}
        setPopupShow={setStockPopupShow}
        size="xl"
        dialogClassName="supplier-stock-modal"
        bodyClassName="supplier-stock-modal-body"
      >
        <ProductStockForm
          product={stockProduct}
          suppliers={suppliers}
          setPopupShow={setStockPopupShow}
          refreshList={() => setProductReload((prev) => prev + 1)}
        />
      </PopupModal>
    </>
  );
};

export default SupplierStockBlock;
